export default __webpack_public_path__ + "static/media/avator.f6703c5e.png";